import {React} from 'react'
import "./WhatsApp.scss";

export default function WhatsApp() {
  return (
    <>
      <a
        target="blank"
      href="https://wa.me/5493885970486"
        className="whatsapp-button">
        <i className="fab fa-whatsapp"></i>
      </a>
    </>
  );
}
